// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialList_wrapper__uVG-x","list":"SocialList_list__OBQCC","icon":"SocialList_icon__87IQZ"};